import { render, staticRenderFns } from "./SeventhComponent.vue?vue&type=template&id=3e708482"
import script from "./SeventhComponent.vue?vue&type=script&lang=js"
export * from "./SeventhComponent.vue?vue&type=script&lang=js"
import style0 from "./SeventhComponent.vue?vue&type=style&index=0&id=3e708482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports